import { createFeatureSelector, createSelector } from "@ngrx/store";
import { User } from "../../interfaces/user.interface";
import { USER_STATUS } from "../../user.status";
import { UserState } from "../../interfaces/user-state.interface";

const selectUsersFeatureState = createFeatureSelector<UserState>("user");

export const selectLogonsList = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state.data,
);

export const selectPageOptions = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state.accountResponse?.page,
);

export const selectMyAudits = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state.myAudits,
);

export const selectMyAuditsPage = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state.myAudits?.data?.page,
);

export const selectMyAuditsError = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state.myAudits?.error,
);

export const selectCompanyInfo = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state.accountResponse?.company,
);

export const selectUsersWithStatus = createSelector(
  selectUsersFeatureState,
  selectLogonsList,
  (state) => {
    return {
      ...state,
      data: usersWithStatus(state.users),
    };
  },
);

export const usersWithStatus = (users: User[]) => {
  const usersWithStatus = users.map((user) => {
    return {
      ...user,
      statusClass: USER_STATUS[user.status || ""] || "",
    };
  });
  return usersWithStatus.slice(0, 10);
};

export const selectLogons = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.logons,
);

export const selectLogon = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.selectedLogon,
);

export const selectUserMeInfo = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.userMeInfo,
);

export const selectCloneableLogonSearch = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.cloneableLogonSearch,
);

export const selectClonedLogon = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.clonedLogon,
);

export const selectResetStatus = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.resetStatus,
);

export const selectToggleSidenav = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.openSidenav,
);

export const selectError = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.selectedLogon?.error,
);

export const selectErrorListing = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.error,
);

export const selectErrorUserAccount = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.error,
);

export const selectUpdateUserAccount = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.updateUserAccount,
);

export const selectErrorUpdateUserAccount = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.updateUserAccount?.error,
);

export const selectFilterParams = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.filterParams,
);

export const selectIsLoadingSkeleton = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.isLoading,
);

export const selectEmptyList = createSelector(
  selectUsersFeatureState,
  (state: UserState) => state?.showEmptyList,
);
